<template>
    <div class="js-author-detail">
        <div class="content-header">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'adminUserList' }">管理员管理</router-link>
                </li>
                <li class="active">(重置密码)</li>
            </ol>
        </div>
        <div class="content-from">
            <el-form ref="formName" :model="saveModel" :rules="rules">
                <el-form-item label="账号" prop="username">
                    <el-input disabled v-model="saveModel.username"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input type="password" v-model="saveModel.password"></el-input>
                </el-form-item>
                <el-form-item label="密码确认" prop="confirmPassword">
                    <el-input type="password" v-model="saveModel.confirmPassword"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="resetPassword">重置密码</el-button>
                    <el-button @click="$router.back(-1)">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        var _this = this;
        var confirmPasswordValidator = function(rule, value, callback) {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== _this.saveModel.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        var passwordValidator = function(rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (_this.saveModel.confirmPassword !== '') {
                    _this.$refs.formName.validateField('confirmPassword');
                }
                callback();
            }
        };
        return {
            saveModel: {
                username: '',
                password: '',
                confirmPassword: '',
            },
            userId: [],
            rules: {
                password: [{
                    validator: passwordValidator,
                    trigger: "blur"
                }],
                confirmPassword: [{
                    validator: confirmPasswordValidator,
                    trigger: "blur"
                }],
            },
        }
    },
    created() {
        var _this = this;
        _this.userId = _this.$route.query.userId;
    },
    mounted() {
        var _this = this;
        if (_this.userId) {
            _this.detailLocalUser();
        }
    },
    methods: {
        detailLocalUser() {
            var _this = this;
            _this.$common.my_ajax({
                url: '/localUser/findUserRoleDetail',
                data: {
                    userId: _this.userId
                },
                success: function(response) {
                    if (response.items) {
                        _this.saveModel = response.items[0];
                        _this.saveModel.password = "";
                    }
                }
            });
        },
        resetPassword() {
            var _this = this;
            _this.$refs['formName'].validate((valid) => {
                if (valid) {
                    _this.$common.my_ajax({
                        url: '/localUser/resetPassword',
                        data: _this.saveModel,
                        success: function(response) {
                            _this.$message({
                                message: '保存成功',
                                type: 'success',
                                duration: 1000,
                                onClose: function() {
                                    _this.$router.push({ name: 'adminUserList' });
                                }
                            });
                        }
                    });
                }
            });
        },
    },
}
</script>
<style scoped>
</style>